module.exports = __webpack_public_path__ + "img/nomess.c4056612.png";